import { PaymentsTable } from "@/features/payments/payments-table";

export function PaymentsListScreen() {
  return (
    <div className="p-4">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Payments</h1>
        <p className="text-gray-600 mt-2">
          View and manage all payment transactions
        </p>
      </div>
      <PaymentsTable />
    </div>
  );
}
